export function addHashQueryParam (url, key, value) {
  const existing = (url.lastIndexOf('?') > url.lastIndexOf('#'))
    ? url.substr(url.lastIndexOf('?') + 1) : ''

  const query = new URLSearchParams(existing)
  query.set(key, value)
  return `${url.replace(`?${existing}`, '')}?${query.toString()}`
}
